export const convertToBase64 = (imageFile) => {
  return new Promise((resolve, reject) => {
    if (!imageFile) {
      resolve(null);
      return;
    }
    try {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(imageFile);
    } catch (error) {
      reject(error);
    }
  });
};

const handleDownload = (imageGeneration) => {
  const link = document.createElement("a");
  link.href = imageGeneration.image.imageUrl;
  link.target = "_blank"; 
  link.rel = "noopener noreferrer";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link); 
};

export const DOWNLOAD_IMAGE_MENU_ITEM = {
  label: "Download",
  action: handleDownload,
}
